import * as React from 'react';

const ChevronDown12: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M7.46967 5.46966C7.76256 5.17679 8.23733 5.17677 8.53022 5.46966L12.5302 9.46966C12.8229 9.76256 12.823 10.2374 12.5302 10.5302C12.2374 10.823 11.7626 10.8229 11.4697 10.5302L7.99994 7.06048L4.53022 10.5302C4.23738 10.823 3.76258 10.8229 3.46967 10.5302C3.17678 10.2373 3.17678 9.76255 3.46967 9.46966L7.46967 5.46966Z'
			fill='currentColor'
		/>
	</svg>
);

export default ChevronDown12;
